import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { Merchant } from './types';

export const getMerchantList = async () => {
  const { merchants } = await fetchAPI<{
    merchants: Merchant[];
  }>('v1/merchant');

  return merchants.map((merchant) => ({
    ...merchant,
    processingFee: merchant.processingFee,
    gatewayFee: merchant.gatewayFee,
    settlementFee: merchant.settlementFee,
    ...(merchant.deletedAt ? { deletedAt: new Date(merchant.deletedAt) } : {}),
  }));
};

export const getMerchant = async (merchantId: string) => {
  const merchant = await fetchAPI<Merchant>(`v1/merchant/${merchantId}`);

  return {
    ...merchant,
    processingFee: merchant.processingFee,
    ...(merchant.deletedAt ? { deletedAt: new Date(merchant.deletedAt) } : {}),
  };
};
